import { render, staticRenderFns } from "./SelectedTopicCreate.vue?vue&type=template&id=1913e42b&scoped=true&"
import script from "./SelectedTopicCreate.vue?vue&type=script&lang=js&"
export * from "./SelectedTopicCreate.vue?vue&type=script&lang=js&"
import style0 from "./SelectedTopicCreate.vue?vue&type=style&index=0&id=1913e42b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1913e42b",
  null
  
)

export default component.exports